import Box from 'components/shared/Box'
import styled, { css } from 'styled-components/macro'
import { fadeInOnRender } from 'styles/animations'
import { respondAbove } from 'styles/mediaQueries'

// elements
export const PalmLeafsLeft = styled.img`
    position: absolute;
    left: 0;
    top: 6px;
    margin: 0;
    display: none;

    @media ${respondAbove.xl} {
        display: block;
    }
`

export const PalmLeafsLeftSm = styled(PalmLeafsLeft)`
    top: 0;
    display: block;

    @media ${respondAbove.xl} {
        display: none;
    }
`

export const PalmLeafsRight = styled.img`
    position: absolute;
    right: 0;
    top: 0;
    margin: 0;
    display: none;

    @media ${respondAbove.xl} {
        display: block;
    }
`

export const PalmLeafsRightSm = styled(PalmLeafsRight)`
    display: block;

    @media ${respondAbove.xl} {
        display: none;
    }
`

export const TicketSeparator = styled.img`
    display: none;

    @media ${respondAbove.xl} {
        min-height: 60px;
        display: block;
    }
`

export const TicketSeparatorSm = styled.img`
    min-height: 40px;
    display: block;

    @media ${respondAbove.xl} {
        display: none;
    }
`

// sections
interface CityBreakInfoWrapperProps {
    isSectionOpened: boolean
}

export const CityBreakInfoWrapper = styled(Box)<CityBreakInfoWrapperProps>`
    padding: 0;
    position: relative;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    ${fadeInOnRender}

    @media ${respondAbove.xl} {
        ${({ isSectionOpened }) =>
            isSectionOpened
                ? css`
                      padding: 32px 40px 0 80px;
                  `
                : css`
                      padding: 32px 40px 32px 80px;
                  `};
    }
`

export const CityBreakContentWrapper = styled(Box)`
    ${fadeInOnRender}
`

// main wrapper
export const CityBreakContainer = styled(Box)`
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    border-radius: 8px;
`
